/*
 *
 * BookingDetailActionsPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 19-Mar-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  cloneDescription: (
    <PortalMessage
      id='t.app.bookingManagent.detail.actionsPopup.cloneDescription'
      defaultMessage='Proceeding a new booking will be created with the same data as this one.'
    />
  ),
  cardSubstitutionLinkDescription: (
    <PortalMessage
      id='t.app.bookingManagent.detail.actionsPopup.cardSubstitutionLinkDescription'
      defaultMessage='Proceeding, a pay-by-link will be created to be sent to the customer to replace the card to guarantee the booking.'
    />
  ),
  date: <PortalMessage id='t.app.bookingManagent.detail.actionsPopup.date' defaultMessage='Date' />,
  time: <PortalMessage id='t.app.bookingManagent.detail.actionsPopup.time' defaultMessage='Time' />,
  cancelTime: <PortalMessage id='t.app.bookingManagent.detail.actionsPopup.cancelTime' defaultMessage='Cancel Time' />,
  amount: <PortalMessage id='t.app.bookingManagent.detail.actionsPopup.amount' defaultMessage='Amount*' />,
  description: (
    <PortalMessage id='t.app.bookingManagent.detail.actionsPopup.description' defaultMessage='Description' />
  ),
  externalPaymentChannel: (
    <PortalMessage id='t.app.bookingManagent.detail.actionsPopup.paymentChannel' defaultMessage='Payment Channel*' />
  ),
  externalPaymentChannelDetails: (
    <PortalMessage
      id='t.app.bookingManagent.detail.actionsPopup.paymentChannelDetail'
      defaultMessage='Payment Channel Details*'
    />
  ),
  mandatoryField: (
    <PortalMessage id='t.app.terminalsManagement.disputeless.form.requiredField' defaultMessage='* Mandatory field' />
  ),
  confirm: <PortalMessage id='t.app.project.btn.confirm' defaultMessage='Confirm' />,
  amountError: (
    <PortalMessage
      id='t.app.bookingManagent.detail.actionsPopup.amountError'
      defaultMessage='Amount must be greater than 0'
    />
  )
}
export const captions = defineMessages({
  booking: {
    id: 't.app.booking.title.actionsModal',
    defaultMessage: 'Booking'
  },
  remainingCharacters: {
    id: 't.app.moto.request.remainingCharacters',
    defaultMessage: ' remaining characters'
  },
  remainingCharacter: {
    id: 't.app.moto.request.remainingCharacter',
    defaultMessage: ' remaining character'
  },
  isRequired: {
    id: 't.app.project.error.isRequired',
    defaultMessage: 'This field is required'
  },
  calendar: {
    id: 't.app.accessibility.icons.input.calendar.ariaLabel',
    defaultMessage: 'Calendar icon'
  },
  // ACTIONS LIST:
  PAYBYLINK: {
    id: 't.app.booking.actions.payByLink',
    defaultMessage: 'Pay-by-link'
  },
  BILL: {
    id: 't.app.booking.actions.bill',
    defaultMessage: 'Bill'
  },
  DISCOUNT: {
    id: 't.app.booking.actions.discount',
    defaultMessage: 'Discount'
  },
  PAYMENT: {
    id: 't.app.booking.actions.payment',
    defaultMessage: 'Payment'
  },
  EXTERNAL_PAYMENT: {
    id: 't.app.booking.actions.externalPayment',
    defaultMessage: 'External Payment'
  },
  EXTERNAL_REFUND: {
    id: 't.app.booking.actions.externalRefund',
    defaultMessage: 'External Refund'
  },
  SEND_LINK: {
    id: 't.app.booking.actions.sendLink',
    defaultMessage: 'Send Link'
  },
  CARD_SUBSTITUTION_LINK: {
    id: 't.app.booking.actions.cardSubstitutionLink',
    defaultMessage: 'Card Substitution Link'
  },
  CHECKIN: {
    id: 't.app.booking.actions.checkIn',
    defaultMessage: 'Check In'
  },
  CHECKOUT: {
    id: 't.app.booking.actions.checkOut',
    defaultMessage: 'Check Out'
  },
  CANCEL: {
    id: 't.app.booking.actions.cancel',
    defaultMessage: 'Cancel'
  },
  DELAYED_CHARGE: {
    id: 't.app.booking.actions.delayedCharge',
    defaultMessage: 'Delayed Charge'
  },
  NO_SHOW: {
    id: 't.app.booking.actions.noShow',
    defaultMessage: 'No Show'
  },
  CLONE: {
    id: 't.app.booking.actions.clone',
    defaultMessage: 'Clone'
  },
  AUTHORIZATION: {
    id: 't.app.operationsmanagement.operationType.authorization',
    defaultMessage: 'AUTHORIZATION'
  },
  CAPTURE: {
    id: 't.app.operationsmanagement.operationType.capture',
    defaultMessage: 'CAPTURE'
  },
  REFUND: {
    id: 't.app.operationsmanagement.operationType.refound',
    defaultMessage: 'REFUND'
  },
  OCT: { 
    id: 't.app.operationsmanagement.operationType.payToCard',
    defaultMessage: 'PAY-TO-CARD'
  },
  externalPaymentChannelDetails: {
    id: 't.app.bookingManagent.detail.actionsPopup.paymentChannelDetail',
    defaultMessage: 'Payment Channel Details*'
  },
  amount: {
    id: 't.app.bookingManagent.detail.actionsPopup.amount',
    defaultMessage: 'Amount*'
  },
  description: {
    id: 't.app.bookingManagent.detail.actionsPopup.description',
    defaultMessage: 'Description'
  },
  date: { id: 't.app.bookingManagent.detail.actionsPopup.date', defaultMessage: 'Date' },
  cancelDate: { id: 't.app.bookingManagent.detail.actionsPopup.cancelDate', defaultMessage: 'Cancel Date' },
  pos: {
    id: 't.app.booking.actions.paymentChannel.pos',
    defaultMessage: 'Pos'
  },
  cash: {
    id: 't.app.booking.actions.paymentChannel.cash',
    defaultMessage: 'Cash'
  },
  bankTransfer: {
    id: 't.app.booking.actions.paymentChannel.bankTransfer',
    defaultMessage: 'Bank Transfer'
  },
  other: {
    id: 't.app.booking.actions.paymentChannel.other',
    defaultMessage: 'Other'
  }
})

export const messages = {
  noShow72HourWarning: {
    id: 't.app.bookingManagent.detail.actionsPopup.noShow72HourWarning',
    defaultMessage: 'Attention! You are exceeding the 72-hour window required by the card scheme rules.'
  },
  noShowExceptionAcceptance: {
    id: 't.app.bookingManagent.detail.actionsPopup.noShowExceptionAcceptance',
    defaultMessage: 'I agree to proceed under an exception to the Disputeless service constraints.'
  },
  warningAriaLabel: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  }
}

export default formattedMessage
